(() => {
  'use strict';
  const track = document.getElementById('players-track');
  const play = document.getElementById('players-play');
  const prev = document.getElementById('players-prev');
  const next = document.getElementById('players-next');
  if (!track || !play || !prev || !next) return;
  track.querySelectorAll('.player-affiliation img').forEach(img => {
    img.addEventListener('error', () => { img.hidden = true; });
  });
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let timer = null;
  function stop() {
    window.clearInterval(timer);
    timer = null;
    play.textContent = 'Play rotation';
    play.setAttribute('aria-pressed', 'false');
  }
  function move(direction) {
    const cards = Array.from(track.children);
    const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    const end = Math.max(0, track.scrollWidth - track.clientWidth);
    let left = track.scrollLeft + direction * step;
    if (direction > 0 && track.scrollLeft >= end - 2) left = 0;
    if (direction < 0 && track.scrollLeft <= 2) left = end;
    track.scrollTo({left: Math.max(0, Math.min(end, left)), behavior: reduced.matches ? 'instant' : 'smooth'});
  }
  play.addEventListener('click', () => {
    if (timer !== null) { stop(); return; }
    timer = window.setInterval(() => move(1), 4500);
    play.textContent = 'Pause rotation';
    play.setAttribute('aria-pressed', 'true');
  });
  prev.addEventListener('click', () => { stop(); move(-1); });
  next.addEventListener('click', () => { stop(); move(1); });
  track.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault(); stop(); move(event.key === 'ArrowRight' ? 1 : -1);
    }
  });
  ['pointerdown', 'mouseenter', 'focusin', 'wheel'].forEach(type => track.addEventListener(type, stop, {passive:true}));
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  reduced.addEventListener('change', stop);
  document.querySelector('.players-controls').hidden = false;
})();
